import { Box, Typography } from "@mui/material";
import React, {useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./defineSlice";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

export default function ChartTableToggle() {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const [isGraphicalView, setIsGraphicalView] = useState(true);

   const { showChart } = define;

   function toggle() {
      dispatch(setState("showChart", !showChart));
   }

   return (
      <Box
      sx={{ width: 260, display: "flex", justifyContent: "center" }}
    >  
      <div style={{
        display: 'flex',
        borderRadius: '24px',
        overflow: 'hidden',
        boxShadow: '0 0 4px #ccc',
      }}>
        <button
          onClick={toggle}
          style={{
            padding: '8px 16px',
            fontSize: '14px',
            border: 'none',
            backgroundColor: showChart ? '#404FA6' : 'rgba(255, 255, 255, 0.833)',
            color: showChart ? '#fff' : '#000',
            borderRadius: '24px 0 0 24px',
            cursor: 'pointer',
            transition: '0.2s ease',
          }}
        >
          Graphical View
        </button>
        <button
          onClick={toggle}
          style={{
            padding: '8px 16px',
            fontSize: '14px',
            border: 'none',
            backgroundColor: !showChart ? '#404FA6' : 'rgba(255, 255, 255, 0.833)',
            color: !showChart ? '#fff' : '#000',
            borderRadius: '0 24px 24px 0',
            cursor: 'pointer',
            transition: '0.2s ease',
          }}
        >
          Table View
        </button>
      </div>
    </Box>
    
    
   );
}
